import react, { useState } from "react";
import styles from "./Footer.module.css";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import FiberManualRecordRoundedIcon from "@mui/icons-material/FiberManualRecordRounded";
import OrgLogo from "../../../assets/imgs/takbir-lms-learning-management-system-muslim-logo-3x-white.png";
import afnanlogo from "../../../assets/imgs/main-website/afnanlogo.jpg";
import fbIcon from "../../../assets/imgs/main-website/footerIcon/fbIcon.jpg";
import WhatsappRounded from "../../../assets/imgs/main-website/footerIcon/WhatsappRounded.svg";
import YouTubeRounded from "../../../assets/imgs/main-website/footerIcon/YouTubeRounded.svg";
import TwitterRounded from "../../../assets/imgs/main-website/footerIcon/TwitterRounded.svg";
import InstagramRounded from "../../../assets/imgs/main-website/footerIcon/Instagram.png";
import Button from "@mui/material/Button";
import { style } from "@mui/system";

import Image from "next/image";
import Link from "next/link";
import Tooltip from "../Tooltip/Tooltip";
import { FacebookIcon } from "./Icons/FacebookIcon";
import { InstagramIcon } from "./Icons/InstagramIcon";
import { YouTubeIcon } from "./Icons/YouTubeIcon";
import { LinkedInIcon } from "./Icons/LinkedInIcon";
import { getUserData } from "../../../hooks/HelperFunctions";
import { apiRequest } from "../../../utils/axiosInstance";
import SimpleBackdrop from "../../Backdrop/SimpleBackdrop";

function Footer() {
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const year = new Date().getFullYear();

  const getStartedHandler = async (e) => {
    e.preventDefault()
    const userInfo = getUserData()
    

    if (userInfo && Object.keys(userInfo).length > 0) {

      setOpenBackdrop(true); // show loading spinner/backdrop

      try {
        const postData = {};
        
        const response = await apiRequest("/generateLoginCode", "POST", postData);

        const { code } = response;

        if (code) {

          // Construct Become a teacher URL with code
          const appBUrl = `${process.env.NEXT_PUBLIC_BECOME_A_TEACHER_URL}?code=${encodeURIComponent(code)}`;


          window.location.href = appBUrl;
        } else {
          console.error("No code returned from API");
        }

      } catch (error) {
        console.error("Error generating login code:", error);
      } finally {
        setOpenBackdrop(false);
      }
    } else {
      router.push("/teach")
      // console.log("No user found");

      // sessionStorage.setItem("from_become_a_teacher", true);

      // setOpenSignUpModel(true)
    }

  }

  /**
   * close backdrop
   */
  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };

  return (
    <div className={styles.Footer}>
      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
      <Container maxWidth="lg">
        <div className={styles.FooterTopSection}>
          <div className={styles.FooterTopLeftSection}>
            <div className={styles.FooterTopSectionTitle}>
              Crafted with <span>❤</span> in Knowledge
            </div>
            <div className={styles.FooterTopSectionSubTitle}>
              Make a global impact with your knowledge & skills.
            </div>
          </div>

          <div className={styles.FooterTopRIghtSection}>
            <Button
              variant="text"
              href="https://www.facebook.com/mytakbir/"
              target="_blank"
            >
              <FacebookIcon />
            </Button>
            <Button
              variant="text"
              href="https://www.instagram.com/my.takbir/"
              target="_blank"
            >
              <InstagramIcon />
            </Button>
            <Button
              variant="text"
              href="https://www.youtube.com/@TakbirLMS"
              target="_blank"
            >
              <YouTubeIcon />
            </Button>
            <Button
              variant="text"
              href="https://www.linkedin.com/company/mytakbir"
              target="_blank"
            >
              <LinkedInIcon />
            </Button>
          </div>
        </div>

        <div className={styles.Divider}></div>

        <div className={styles.GridBox}>
          {/* GRID START*/}
          <div className={styles.Grid}>
            <div className={styles.FooterLogo}>
              <a href="/">
                <Image className={styles.DcLogo} alt="icon" src={OrgLogo} />
              </a>
            </div>

            <div className={styles["FooterCol"]}>
              <p className={styles.Details} style={{ maxWidth: "400px" }}>
                Takbir is a secured, simple and easy-to-use online learning
                platform for learners (knowledge seekers) and amazing mu’allim
                (teachers) of our Deen.
              </p>
            </div>
          </div>
          {/* GRID END*/}

          {/* GRID START*/}
          <div className={styles.Grid}>
            <div className={styles.FooterCol}>
              <h1>Takbir</h1>
              <span>
                <Link href="/search">Explore Courses</Link>
              </span>
              <span>
                <Link href="/teach" onClick={(e) => getStartedHandler(e)}>Become a teacher</Link>
              </span>
              <span>
                <Link
                  href="https://meet.mytakbir.com/contact-us?utm_source=tkbr-web&utm_medium=tkbr-footer"
                  target="_blank"
                >
                  Contact Us
                </Link>
              </span>
            </div>
          </div>
          {/* GRID END*/}

          {/* GRID START*/}
          <div className={styles.Grid}>
            <div className={styles.FooterCol}>
              <h1>Support</h1>

              <span>
                <Link href="https://support.mytakbir.com/" target="_blank">
                  Help
                </Link>
              </span>

              <span>
                <Link href="https://support.mytakbir.com/" target="_blank">
                  Knowledge Center
                </Link>
              </span>
            </div>
          </div>
          {/* GRID END*/}

          {/* GRID START*/}
          <div className={styles.Grid}>
            <div className={styles.FooterCol}>
              <h1>MORE</h1>
              <span>
                <Link href="https://legal.mytakbir.com/terms" target="_blank">
                  Terms
                </Link>
              </span>
              <span>
                <a href="https://legal.mytakbir.com/privacy-policy" target="_blank">
                  Privacy Policy
                </a>
              </span>

              <span>
                <a href="https://legal.mytakbir.com/teaching-account-terms" target="_blank">
                  Instructor Terms
                </a>
              </span>

              <span>
                <a href="https://blog.mytakbir.com/blogs" target="_blank">
                  Blog
                </a>
              </span>
            </div>
          </div>
          {/* GRID END*/}
        </div>

        <div className={styles.Divider}></div>
        <div className={styles.AllRightReserved}>
          © {year} Takbir. All rights reserved.
        </div>
      </Container>

    </div>
  );
}

export default Footer;
